export default __webpack_public_path__ + "static/media/defaultAvatar.4263af8c.png";